export const SET_PARTICIPANT_TO_ACCOSIATE = 'SET_PARTICIPANT_TO_ACCOSIATE';
export const SET_CONTACT_TO_ACCOSIATE = 'SET_CONTACT_TO_ACCOSIATE';
export const SET_NEW_CONTACT_EMAIL = 'SET_NEW_CONTACT_EMAIL';
export const GET_ASSOCIATION_SECTION_LIST = 'GET_ASSOCIATION_SECTION_LIST';
export const SET_ASSOCIATIONS = 'SET_ASSOCIATIONS';
export const SET_ASSOCIATIONS_LOADING = 'SET_ASSOCIATIONS_LOADING';
export const ASSOCIATE_OBJECT = 'ASSOCIATE_OBJECT';
export const DISASSOCIATE_OBJECT = 'DISASSOCIATE_OBJECT';
export const initialState = {
  participantToAssociate: {},
  contactToAssociate: {},
  newContactEmail: '',
  associations: [],
  associationsLoading: false
};
export const reducer = (state, action) => {
  switch (action.type) {
    case SET_PARTICIPANT_TO_ACCOSIATE:
      return Object.assign({}, state, {
        participantToAssociate: action.payload
      });
    case SET_CONTACT_TO_ACCOSIATE:
      return Object.assign({}, state, {
        contactToAssociate: Object.assign({}, action.payload, {
          id: Number(action.payload.id)
        })
      });
    case SET_NEW_CONTACT_EMAIL:
      return Object.assign({}, state, {
        newContactEmail: action.payload
      });
    case SET_ASSOCIATIONS:
      return Object.assign({}, state, {
        associations: action.payload
      });
    case SET_ASSOCIATIONS_LOADING:
      return Object.assign({}, state, {
        associationsLoading: action.payload
      });
    default:
      return state;
  }
};